<template>
  <div>

    <v-navigation-drawer
        v-model="drawer"
        app
    >
      <v-list dense>
        <v-list-item v-for="links in managerArea" :key="links.title" :to="links.route" :value="links.icon"
                     exact link>
          <v-list-item-action>
            <v-icon>{{ links.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ links.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item exact
                     link @click="logout">
          <v-list-item-action>
            <v-icon>mdi-login-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


      </v-list>
    </v-navigation-drawer>

    <v-app-bar
        app

        dark
        height="75"


    >
      <v-app-bar-nav-icon @click.stop.native="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="title">Nite</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-img

          max-height="64"
          max-width="64"
          src="@/assets/logo.png"
      ></v-img>

    </v-app-bar>
  </div>
</template>

<script>


import {
  mdiAccountGroup,
  mdiAccountTie,
  mdiAccountTieVoice,
  mdiBookAlphabet,
  mdiGlassCocktail,
  mdiGoogleAnalytics,
} from "@mdi/js";
import {mapMutations} from "vuex";


export default {
  name: "NavBar",
  data() {
    return {
      managerArea: [
        {
          icon: mdiAccountTie,
          route: '/',
          title: 'Manager Area'
        },
        {
          icon: mdiAccountGroup,
          route: '/employees',
          title: 'Employees'
        },
        {
          icon: mdiGlassCocktail,
          route: '/products',
          title: 'Products'
        },
        {
          icon: mdiBookAlphabet,
          route: '/menus',
          title: 'Menus'
        },
        {
          icon: mdiAccountTieVoice,
          route: '/public-relations',
          title: 'Public Relations'
        },
        {
          icon: mdiGoogleAnalytics,
          route: '/public-relations/stats',
          title: 'PR Stats '
        }


      ],

      drawer: null,


    }
  },

  computed: {},

  methods: {

    ...mapMutations({

      setToken: 'auth/SET_TOKEN',
      setRefreshToken: 'auth/SET_REFRESH_TOKEN',
      setManager: 'auth/SET_USER'

    }),

    logout() {

      this.setRefreshToken(null);
      this.setToken(null);
      this.setManager(null);
      this.$router.push('/sign-in')


    }


  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Comfortaa&display=swap');

.title {
  font-family: 'Comfortaa', cursive;

}

</style>